import { ScoopText } from '../../../../ui'
import styles from './BlufStatement.module.scss'

/**
 * BlufStatement — the single "Bottom Line" treatment for every report view
 * (target-state design, review D19). The answer zone of a report: an overline
 * label plus the bottom-line statement set at a readable measure. Deliberately
 * NOT a ScoopAlert — alerts are for alerts; this is content.
 */
export const BlufStatement = ({ children, label = 'Bottom Line' }) => {
    if (!children) return null
    return (
        <div className={styles.bluf}>
            <ScoopText className={styles.blufLabel}>{label}</ScoopText>
            <ScoopText className={styles.blufText}>{children}</ScoopText>
        </div>
    )
}
